var _defs, _polygon, _rect, _rect2, _path, _rect3, _path2, _rect4, _g, _path3, _circle, _circle2, _circle3, _rect5, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 386.42 290.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 203.65,
    y1: 257.16,
    x2: 193.77,
    y2: -99.92,
    gradientTransform: "matrix(1, 0, 0, -1, -13.88, 321.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 10.1,
    y1: 271.76,
    x2: 288.38,
    y2: 55.85,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 352)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M170.58,36.08a81.92,81.92,0,0,0-21.19,10c-12.31,8.26-21.8,20-32.6,30.15-17.62,16.6-38.72,29-57.66,44.1s-36.36,34-42.32,57.44C5.36,222.85,28.47,286.39,68.66,311.26c24.64,15.24,56.73,12.12,83.85,1.94s51.48-26.63,78.24-37.72c5.38-2.22,11.08-4.26,16.87-3.68s10.78,3.59,16,6a82.91,82.91,0,0,0,53.87,5.6,99.61,99.61,0,0,0,29.76-12.88c32.15-20.27,54.25-57.2,53-95.19s-27.88-74.84-64.65-84.49c-12.3-3.23-25.23-3.54-37.54-6.75-16.28,0-31.72-24.22-41.34-34.38-4.88-5.15-9.88-10.4-16.16-13.68-7.29-3.81-15.72-4.68-23.93-5C201.15,30.36,185.21,31.48,170.58,36.08Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#68e1fd",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,277.33c-4.53,4.56-11.94,4.08-18,6.37l1.2,1.5c-.42,1.12-1.92,1.28-3.12,1.25-12.67-.33-25.82.28-38.4-1.08,2.38-3.05,6.15-3.25,9.63-3.85,5.33-.91,10.54-2.33,15.91-3.09A143.26,143.26,0,0,1,167,277.33Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#020202",
    opacity: 0.14,
    style: {
      isolation: "isolate"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "224.87 222.62 141.08 222.62 150.14 193.48 213.61 193.48 224.87 222.62",
    fill: "#68e1fd"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "147.82 200.93 220.99 212.56 213.61 193.48 150.14 193.48 147.82 200.93",
    fill: "#020202",
    opacity: 0.14,
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.21,
    y: 73.07,
    width: 217.21,
    height: 122.48,
    rx: 12.81,
    fill: "#68e1fd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.21,
    y: 73.34,
    width: 217.21,
    height: 122.48,
    rx: 12.81,
    fill: "url(#linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.31,212.15v1.43c0,7.08-5.74,12.81-13.32,17.49H105.39c-6.56-4.68-12.3-10.41-12.3-17.49v-1.43Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#68e1fd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 132.65,
    y: 219.58,
    width: 102.01,
    height: 3.03,
    fill: "#68e1fd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.15,190.41h25.78a6.54,6.54,0,0,0,6.44-6.64h0V127.26a6.54,6.54,0,0,0-6.44-6.64H93.15Z",
    transform: "translate(-13.88 -30.85)",
    fill: "url(#linear-gradient-2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 89.77,
    width: 66.49,
    height: 65.44,
    rx: 5.85,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_5rJZo6",
    "data-name": " 5rJZo6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.18,131.45h32.15c-.17.48-.28.87-.44,1.25Q96,151.58,88.17,170.48c-.45,1.1-1,1.59-2.21,1.47a34.05,34.05,0,0,0-3.5,0l15-36.19H80.16l3.75,6.1-6.29,6.51H88.09c-.67,1.44-1.22,2.69-1.84,3.9a1,1,0,0,1-.76.31h-17c-.11,0-.22-.09-.73-.58a4.93,4.93,0,0,0,1.24-.66c2.89-2.84,5.74-5.73,8.65-8.56a1.16,1.16,0,0,0,.27-1.63l-.07-.09Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#68e1fd"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 146.97,
    cy: 120.14,
    r: 19.53,
    fill: "#fff",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262.81,
    cy: 120.14,
    r: 19.53,
    fill: "#fff",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.65,165.42v-3.55a10.18,10.18,0,0,1-5.37-1.53l.82-2.37a9.24,9.24,0,0,0,5,1.47c2.52,0,4.19-1.44,4.19-3.44s-1.37-3.13-4-4.19c-3.59-1.4-5.81-3-5.8-6.07,0-2.91,2.06-5.13,5.29-5.67v-3.54H162v3.4a9.38,9.38,0,0,1,4.57,1.22l-.86,2.36a8.51,8.51,0,0,0-4.43-1.19c-2.7,0-3.72,1.63-3.72,3,0,1.83,1.31,2.74,4.36,4,3.63,1.47,5.45,3.29,5.46,6.42,0,2.77-1.93,5.38-5.54,6v3.64Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 147.19,
    cy: 151.17,
    r: 4.04,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.56,
    cy: 151.17,
    r: 4.04,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.81,
    cy: 151.55,
    r: 4.04,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 147.82,
    y: 150.19,
    width: 113.48,
    height: 1.36,
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "n5jV8V"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.34,164a6.44,6.44,0,0,1-1.13-.17A10.59,10.59,0,0,1,269,160a12.91,12.91,0,0,1-2.27-4c-.07-.2-.15-.28-.37-.27h-3.8V152h3.34v-1.83h-3.35v-3.77h3.81a.32.32,0,0,0,.36-.26,12.39,12.39,0,0,1,4.9-6.42,9.37,9.37,0,0,1,4.54-1.57h1.57l1.26.21a10.16,10.16,0,0,1,4.61,2.27,12.67,12.67,0,0,1,3.12,4l.06.16-3.37,1.61c-.17-.3-.32-.59-.5-.87a7.42,7.42,0,0,0-3.91-3.3,5.84,5.84,0,0,0-4.42.19,7.88,7.88,0,0,0-3.84,3.88v.12h8.47v3.75H269.7V152h9.49v3.77h-8.5a8.92,8.92,0,0,0,1.45,2.2,6.87,6.87,0,0,0,3.3,2.11,6.06,6.06,0,0,0,5.48-1.16A8.26,8.26,0,0,0,283.3,156c0-.06.07-.12.12-.2l3.42,1.63c-.36.6-.68,1.18-1,1.73a11.41,11.41,0,0,1-2.92,3A9.91,9.91,0,0,1,278,163.9h-.26Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#fff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.47,279.32a10.15,10.15,0,0,0,2.28,2.11c1.12.64,2.88.89,3.54,1.55.48.48,1.74,2.54-2.91,2.5s-6.89.29-7.39-.5.72-5.82.72-5.82A12.83,12.83,0,0,0,111.47,279.32Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#473f47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.78,279.33a10.15,10.15,0,0,0,2.28,2.11c1.12.64,5.24,1.17,5.9,1.83.48.48,1.28,2.4-5.27,2.22-4.65-.13-6.89.29-7.39-.5s.72-5.82.72-5.82A19.7,19.7,0,0,0,136.78,279.33Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#473f47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.69,216.43a128.3,128.3,0,0,0-.46,13.3,90.24,90.24,0,0,1-.3,14.14c-.56,5.85-2.83,19.69-2.91,22.81s.35,13.12.35,13.12l4.54.11s3.82-24.2,4.8-26.67,10-29.65,10.13-31.62S110.69,216.43,110.69,216.43Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#473f47"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.71,216.81s.89,15.26,1.22,18.33.55,14.87.71,16.79,1.1,25.12,2,28h-5.07s-5.19-16.87-5.19-24.86-3.45-17.35-5.67-22.61-7.3-5.39-8.67-15.17C113,217.27,131.86,213.71,133.71,216.81Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#473f47"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.39,175.15a5.79,5.79,0,0,1-1.84,1.57,4.35,4.35,0,0,0,0,2.85c.57,1.18-7.29.47-7.29.47a8.53,8.53,0,0,0-.67-4.46c-3.15-4.15-3.87-6.44-1.73-10.11a5.23,5.23,0,0,1,1.74-1.79,6.26,6.26,0,0,1,5.18-.71,5.77,5.77,0,0,1,2.4,1.51,2.91,2.91,0,0,1,.67,1.17,8.5,8.5,0,0,0,.91,1.71,2,2,0,0,0,.32.45c.32.33.83.45,1.09.83a1.41,1.41,0,0,1,.05,1.28,5.56,5.56,0,0,0-.45,1.26C127.6,172.38,128.15,174.06,127.39,175.15Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#fca89e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.68,162.48a17.73,17.73,0,0,1-1.3,4.63,17,17,0,0,0-1.29,4.18c-.13,1.2-.19,2.4-.44,3.6-.31,1.51-1.16,4.93-1.64,5.35a33.86,33.86,0,0,1-9.18,5.19,36.28,36.28,0,0,0-7.55,3.52c-.31.2-1.42,0-1.77,0h-9.9a5.37,5.37,0,0,1-4-2.49,3.21,3.21,0,0,1-.2-3.71,4.7,4.7,0,0,1,1.3-1c1.32-.8,3.4-2.32,5-2.2l6,.41s2.91.3,3.74.46,6.41-1,7.56-1.12c1.66-.17,3.62-1.88,4.92-2.81,2.14-1.54,2.79-5.37,3.43-7.84a7.28,7.28,0,0,0,0-4.79c-.5-1.08-1.52-2.12-1.18-3.27a1.62,1.62,0,0,1,1.41.41c1-.93,0-2.84,1-3.76.71-.66,1.91-.23,2.59.46a6,6,0,0,1,1.46,4.62A.16.16,0,0,1,151.68,162.48Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#fca89e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.07,169.14c-.06.92-.14,1.84-.26,2.76a14.13,14.13,0,0,1-.32,1.93c-.16.63-.37,1.25-.53,1.89-.4,1.7-.33,3.56-1.25,5a8.42,8.42,0,0,1-1.15,1.38,3.37,3.37,0,0,1-.67.58,8.15,8.15,0,0,1-.83.29,11.07,11.07,0,0,0-1.69.92l-1.91,1c-1.44.71-2.94,1.32-4.36,2.12a8.54,8.54,0,0,0-1.74,1.31c-1.56,1.58-2,3.59-1.91,6.17q.24,10.06.49,20.11a2.08,2.08,0,0,1-.29,1.38,1.21,1.21,0,0,1-.47.34,3.77,3.77,0,0,1-1,.19,111.92,111.92,0,0,1-19.46.12c-3.62-.32-2-1.41-3.81-3.89-1.26-1.75-3.33-2.91-5.19-3.94-2.77-1.52-5.84-3.37-6.55-6.45-.75-3.26,1.48-6.38,3.56-9l7.87-9.83c2.25-2.81,3.69-2.74,6.9-3.18.34,0,4.51-.52,4.53-.76,0,0,.75,1,4.68-.18,0,0,4.68.53,5.45.63a12.72,12.72,0,0,0,6.28-.91,12.2,12.2,0,0,0,5.15-3.38,26.68,26.68,0,0,0,3.84-8.23,1.06,1.06,0,0,1,.53-.75,1,1,0,0,1,.81.17l2.94,1.59.16.1a.29.29,0,0,1,.15.16A.74.74,0,0,1,150.07,169.14Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#68e1fd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M125.79,165.79a2.28,2.28,0,0,0-.92-.49,4.26,4.26,0,0,1-.71,3.08,6.15,6.15,0,0,0-1.1,3,.67.67,0,0,0-.78-.54.58.58,0,0,0-.22.08,1.2,1.2,0,0,0-.56,1.06,2,2,0,0,0,.34,1.2,1.47,1.47,0,0,0,1.81.6c-.5-.2-1,.28-1.17.8a6.2,6.2,0,0,0,0,1.61,3.75,3.75,0,0,1-.58,2.09l-.55-.59a1.9,1.9,0,0,0-.27.8c-.08.27-.34.56-.61.47-.11,0-.2-.14-.32-.14s-.27.25-.39.42c-.28.41-1,.27-1.3-.11a4.59,4.59,0,0,1-.62-1.37c-.19-.46-.57-.93-1.08-.92a.86.86,0,0,1-.39,0,.53.53,0,0,1-.28-.34,28,28,0,0,0-2.1-3.64,19.4,19.4,0,0,1-1.83-2.9,7,7,0,0,1,3.55-9.33,6.61,6.61,0,0,1,1.58-.5c1-.18,2-.16,3-.31.66-.1,1.49-.59,2.15-.5,1.45.2,2.62,2.52,3,3.73a7,7,0,0,1,.28,1.36A9.12,9.12,0,0,0,125.79,165.79Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#473f47"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.9,191c-2.51,1.87-4.23,4.6-5.87,7.27a12.94,12.94,0,0,0-1.58,3.18,4.5,4.5,0,0,0,.25,3.45.61.61,0,0,0,.3.31.73.73,0,0,0,.48-.07l1.52-.63,4.13,7.43c.25-3.22.24-6.52.4-9.75.09-1.89.17-3.78.23-5.67C109.79,195.81,109.42,191.39,109.9,191Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#020202",
    opacity: 0.14,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.07,169.14c-.06.92-.14,1.84-.26,2.76a14.13,14.13,0,0,1-.32,1.93c-.16.63-.37,1.25-.53,1.89-.4,1.7-.33,3.56-1.25,5a8.42,8.42,0,0,1-1.15,1.38,3.37,3.37,0,0,1-.67.58,8.15,8.15,0,0,1-.83.29,11.07,11.07,0,0,0-1.69.92l-1.91,1c-1.44.71-2.94,1.32-4.36,2.12a8.54,8.54,0,0,0-1.74,1.31c-1.56,1.58-2,3.59-1.91,6.17q.24,10.06.49,20.11a2.08,2.08,0,0,1-.29,1.38,1.21,1.21,0,0,1-.47.34,23.79,23.79,0,0,1-3.58.09c2.46-3.85,2-8.82,1.48-13.36A38.38,38.38,0,0,1,131,192.4a14.14,14.14,0,0,1,5.16-9.09c2.54-1.86,5.89-2.59,8.07-4.86A15.44,15.44,0,0,0,147,173.5c.49-1.19,1.24-4.51,2.83-4.84a.29.29,0,0,1,.15.16A.71.71,0,0,1,150.07,169.14Z",
    transform: "translate(-13.88 -30.85)",
    fill: "#020202",
    opacity: 0.14,
    style: {
      isolation: "isolate"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.90a1d59255a98c617fd433a02fc4e692.svg";
export { ForwardRef as ReactComponent };